<template>
  <div class="shop-full">
    <div class="container">
        <div class="shop-single-page-content">
          <div class="shop-single-item-content">

            <div class="row">

              <div class="col-lg-5 col-md-12">
                <div class="shop-single-image">

                  <div class="product-image1">
                    <img src="assets/images/shop/shop-single/ss1.jpg" alt="image" />
                  </div>

                  <div class="product-image-2">
                    <img v-for="(item,i) in shopSingle.smallImg"
                    :key="i" :src="item.img" alt="image" />
                  </div>

							  </div>
              </div><!--/.col-->

              <div class="col-lg-7 col-md-12">
                <div class="shop-single-product-info">
                  <h2>{{shopSingle.title}}</h2>
                  <div class="user-ratings">
                    <p>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <span>
                        {{shopSingle.rating}} customer review
                      </span>
                    </p>
                  </div>
                  <div class="price">
                    <h3>
                      ${{shopSingle.price}}
                      <del>${{shopSingle.offerPrice}}</del>
                    </h3>
                  </div>
                </div><!--/.shop-single-product-info-->

                <div class="fix shop-single-product-feature-part">

                  <div class="shop-single-product-feature">
                      <h3>category : </h3>
                      <p v-for="(item,i) in shopSingle.category" :key="i">
                        <router-link :to="item.link">
                          {{item.title}}
                        </router-link>
                      </p>
                  </div><!--/.shop-single-product-feature-->

                  <div class="shop-single-product-feature">
                      <h3>brand : </h3>
                      <p>{{shopSingle.brandName}}</p>
                  </div><!--/.shop-single-product-feature-->

                  <div class="shop-single-product-feature">
                    <h3>select size:</h3>
                    <div class="model-select-icon">
                        <select class="">
                            <option
                              v-for="(item,i) in shopSingle.selectSize" :key="i"
                              :value="item.value">
                              {{item.txt}}
                            </option><!-- /.option-->
                        </select><!-- /.select-->
                    </div><!-- /.model-select-icon -->
                  </div><!--/.shop-single-product-feature-->

                  <div class="shop-single-product-feature">
                      <h3>quantity :</h3>
                      <form action="#">
                          <div class="product-qty">
                              <div class="quantity-form">
                                  <div class="input-group">
                                      <input type="button" value="-" class="qtyminus">
                                      <input type="text" value="1" class="input-text qty text amount">
                                      <input type="button" value="+" class="qtyplus">
                                  </div><!--/.input-group -->
                              </div><!--/.quantity-form -->
                          </div><!--/.product-qty-->
                      </form><!--/form-->
                  </div><!--/.shop-single-product-feature-->

                  <div class="shop-cart">
                    <router-link to="" class="shop-cart-view">
                      <i class="fa fa-shopping-cart"></i>
                      add to cart
                    </router-link>
                  </div><!--/.shop-cart-->

                </div><!--/.fix-->

                <div class="shop-wishlist">
                  <div class="wishlist-title">
                    <i class="fa fa-heart"></i>add to wishlist
                  </div>
                  <ul class="socal-link">
                    <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#"><i class="fa fa-rss"></i></a></li>
                    <li><a href="#"><i class="fa fa-youtube"></i></a></li>
                    <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                  </ul>
                </div>

              </div><!--/.col-->

            </div><!--/.row-->

            <!-- Description section start -->
            <div class="sh-single-tabs">

                <div id="desc-tabs" class="desc-tabs">

                  <ul class="nav nav-tabs" role="tablist">
                    <li role="presentation" >
                      <a href="#home" aria-controls="description"
                      role="tab" data-toggle="tab">
                      Description
                      </a>
                    </li>
                    <li role="presentation" class="active">
                      <a href="#profile" aria-controls="reviews"
                      role="tab" data-toggle="tab">
                        Reviews (1)
                      </a>
                    </li>
                    <li role="presentation">
                      <a href="#return" aria-controls="return" role="tab" data-toggle="tab">
                        retun and replacement policy
                      </a>
                    </li>
                  </ul>

                  <!-- Tab panes -->
                  <div class="tab-content">

                    <div role="tabpanel" class="tab-pane" id="home">
                      <div class="tab-para">
                        <p>
                          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </p>
                      </div>
                    </div>

                    <div role="tabpanel" class="tab-pane active" id="profile">

                      <div class="media">
                        <img src="assets/images/comment/cmn3.jpg">
                        <div class="media-body">
                            <h3 class="mt-0">Anik Brown</h3>
                            <h5>Octaber 24 , 2017 at 11:</h5>
                            On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee .
                        </div>
                      </div><!--media end-->

                      <div class="sh-single-review">
                        <h3>Add a review</h3>
                        <div class="row">
                          <div class="col-sm-8">
                            <div class="login_panel">
                              <form>
                                <div class="form-group">
                                  <label for="review">review</label>
                                  <textarea  id="review" rows="3"></textarea>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 col-sm-12">
                                    <div class="form-box">
                                      <label for="name">name</label>
                                      <input type="text" id="name" name="name">
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-sm-12">
                                    <div class="form-box">
                                      <label for="email">Email</label>
                                      <input type="email" id="email" name="email">
                                    </div>
                                  </div>
                                </div>
                                <input type="submit" value="Submit">
                              </form>
                            </div>
                          </div>
                        </div>

                      </div><!--sh-single-review end-->

                    </div>

                    <div role="tabpanel" class="tab-pane" id="return">
                      <div class="tab-para">
                        <ul>
                          <li>
                            Terms One
                          </li>
                          <li>
                            Terms Two
                          </li>
                          <li>
                            Terms Three
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div><!--tab content end-->
                </div>

            </div>
            <!-- Description section end -->


            <div class="row">
              <div class="col-xs-12">

                <div class="shop-related-category">
                  <div class="section-title">
                    <h2>{{relatedCarousel.head}}</h2>
                  </div>
                  <div class="container">
                    <offer-owl-carousel
                      :data="relatedCarousel.data"
                      :items="relatedCarousel.items"
                      :margin="relatedCarousel.margin"
                      :loop="relatedCarousel.loop"
                      :autoplay="relatedCarousel.autoplay"
                      :nav="relatedCarousel.nav"
                      :navText="relatedCarousel.navText"
                      :responsive="relatedCarousel.responsive"
                      :dots="relatedCarousel.dots"
                    />
                  </div>
                </div>

              </div>
            </div>

          </div><!-- .shop-single-item-content -->
        </div><!--/.shop-single-page-content-->
    </div><!--/.container-->
  </div><!--/.shop-full-->
</template>


<script>
export default {
  data() {
    return {
      shopSingle: {
        title: 'Basic contrast sneakers',
        rating: '5',
        price: '180',
        offerPrice: '220',
        category:[
          {title:'laptop',link:'/laptop'},
          {title:'desktop',link:'/desktop'}
        ],
        brandName: 'Nikkon',
        selectSize:[
          {value:'xl',txt:'XL'},
          {value:'l',txt:'L'},
          {value:'m',txt:'M'},
          {value:'s',txt:'S'}
        ],
        smallImg:[
          {img:'assets/images/shop/shop-single/sh1.jpg'},
          {img:'assets/images/shop/shop-single/sh2.jpg'},
          {img:'assets/images/shop/shop-single/sh3.jpg'},
          {img:'assets/images/shop/shop-single/sh2.jpg'}
        ]
      },
      relatedCarousel: {
        head: 'related category',
        data: [
          {
            img : "https://bit.ly/2Tp8nZB",
            content : {
              title      : "dummy title",
              details    : "/product/id",
              offerPrice : "$125.00",
              oldPrice   : "",
              btn        :  "add to cart",
              link       :  "/"
            }
          },
          {
            img : "https://bit.ly/2Uh8XGe",
            content : {
              title      : "dummy title",
              details    : "/product/id",
              offerPrice : "$125.00",
              oldPrice   : "",
              btn        :  "add to cart",
              link       :  "/"
            }
          },
          {
            img : "https://bit.ly/2VwFMz4",
            content : {
              title      : "dummy title",
              details    : "/product/id",
              offerPrice : "$125.00",
              oldPrice   : "$250.00",
              btn        :  "add to cart",
              link       :  "/"
            }
          },
          {
            img : "https://bit.ly/2Uh8XGe",
            content : {
              title      : "dummy title",
              details    : "/product/id",
              offerPrice : "$125.00",
              oldPrice   : "$250.00",
              btn        :  "add to cart",
              link       :  "/"
            }
          }
        ],
        items    : 4,
        margin   : 15,
        loop     : true,
        autoplay : false,
        nav      : true,
        dots     : false,
        navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
        responsive:{
          0:{
            items:1,
            nav:false
          },
          640:{
            items:2,
            nav:true
          },
          992:{
            items:3,
            nav:true,
          },
          1199:{
            items:4,
            nav:true
          }
        }
      }
    }
  },
  mounted(){
    this.cartQuantity();

  },
  methods: {
    cartQuantity(){
      $(".qtyplus").on("click", function(){
        var b = $(this).parents(".quantity-form").find("input.qty"),
                c = parseInt(b.val(), 10) + 1,
                d = parseInt(b.attr("max"), 10);
            d || (d = 9999999999), c <= d && (b.val(c), b.change())
      });
      $(".qtyminus").on("click", function(){
        var b = $(this).parents(".quantity-form").find("input.qty"),
              c = parseInt(b.val(), 10) - 1,
              d = parseInt(b.attr("min"), 10);
          d || (d = 0), c >= d && (b.val(c), b.change())
      });
    }
  }
}
</script>


<style>
  .shop-single-page-content{margin:80px 0;}

</style>
